import { useTranslation } from 'react-i18next';
import type { EmailLogEntrySummary } from '@/api/emailLog/emailLogApi.types';
import { Icon } from '@/components/common/Icon';
import { formatIsoDateTimeToTimestamp } from '@/utils/dateFormatting';
import { EmailLogStatusBadge } from './EmailLogStatusBadge';

interface EmailLogEntryRowProps {
  entry: EmailLogEntrySummary;
  onOpen: (entryId: string) => void;
}

export function EmailLogEntryRow({ entry, onOpen }: EmailLogEntryRowProps) {
  const { t } = useTranslation('emailLog');

  return (
    <li>
      <button
        type="button"
        onClick={function openEntry() {
          onOpen(entry.id);
        }}
        className="w-full text-left px-4 sm:px-5 py-4 flex items-start gap-3 hover:bg-zoovpalelavender transition-colors"
      >
        <span className="w-8 h-8 rounded-lg bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name={entry.carriesCredentialLink === true ? 'Lock' : 'Mail'} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="flex items-start justify-between gap-x-3 gap-y-1 flex-wrap">
            <span className="text-[13px] font-semibold text-zooindigo min-w-0 break-words">
              {entry.subject}
            </span>
            <time className="text-[11px] text-zoomuted shrink-0" dateTime={entry.createdAt}>
              {formatIsoDateTimeToTimestamp(entry.createdAt)}
            </time>
          </span>
          <span className="flex items-center gap-x-3 gap-y-1 flex-wrap text-[12px] text-zoomuted mt-1">
            <span className="truncate">{t('row.to', { address: entry.recipientAddress })}</span>
            <EmailLogStatusBadge status={entry.status} />
            {entry.resentFromEntryId === null ? null : (
              <span className="inline-flex items-center gap-1">
                <Icon name="RefreshCw" />
                {t('row.resent')}
              </span>
            )}
          </span>
        </span>
      </button>
    </li>
  );
}
